<header>
    <img src="./assets/img/logo.png" alt="">
    <img [src]="currentImage" (click)="toggleMenuFunc()" alt="">
</header>
